const EMBED_BASE_URL = 'https://maps.google.com/maps/embed/v1/'
const BASE_URL = 'https://maps.googleapis.com/maps/api/'
const STREET_VIEW = 'streetview/'
const METADATA = 'metadata'

const streetViewMetadata = async (
  latitude: number,
  longitude: number,
  apiKey: string
): Promise<any> => {
  const url = `${BASE_URL}${STREET_VIEW}${METADATA}?location=${latitude},${longitude}&key=${apiKey}`
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  return response.json()
}

export { streetViewMetadata, EMBED_BASE_URL, STREET_VIEW }
